import { Heading_2 as Heading2 } from '@huggg/react-components';
import React from 'react';
import { PrepaidLoadingAnimation } from './PrepaidLoadingAnimation';
import styles from './prepaidCard.module.scss';

export const PrepaidLoader = () => {
  return (
    <>
      <div className={styles.loader}>
        <PrepaidLoadingAnimation />
      </div>
      <Heading2 style={{ textAlign: 'center' }}>
        Creating your card... Won't be long.
      </Heading2>
    </>
  );
};
